// import the api endpoints
import VisualResources from '@/services/visualResources.api';

const state = {
  logo: '',
  favicon: '',
  primaryColor: '',
  secondaryColor: '',
  appName: '',
  socialLogin: false,
  googleCaptchaClientID: null,
  loaded: false,
};

const mutations = {
  SET_LOGO(state, logo) {
    state.logo = logo;
  },
  SET_FAVICON(state, favicon) {
    state.favicon = favicon;
  },
  SET_PRIMARY_COLOR(state, primaryColor) {
    state.primaryColor = primaryColor;
  },
  SET_SECONDARY_COLOR(state, secondaryColor) {
    state.socialLogin = secondaryColor;
  },
  SET_APP_NAME(state, appName) {
    state.appName = appName;
  },
  SET_SOCIAL_LOGIN(state, socialLogin) {
    state.socialLogin = socialLogin;
  },
  SET_GOOGLE_CAPTCHA_CLIENT_ID(state, googleCaptchaClientID) {
    state.googleCaptchaClientID = googleCaptchaClientID;
  },
  SET_LOADED(state, loaded) {
    state.loaded = loaded;
  },
};

const getters = {
  logo(state) {
    return state.logo;
  },
  favicon(state) {
    return state.favicon;
  },
  primaryColor(state) {
    return state.primaryColor;
  },
  secondaryColor(state) {
    return state.secondaryColor;
  },
  appName(state) {
    return state.appName;
  },
  socialLogin(state) {
    return state.socialLogin;
  },
  googleCaptchaClientID(state) {
    return state.googleCaptchaClientID;
  },
  loaded(state) {
    return state.loaded;
  },
};

const actions = {
  getVisualResources({ commit }) {
    return VisualResources.visualResources()
      .then(({ data }) => {
        commit('SET_LOGO', data.logo.src);
        commit('SET_FAVICON', data.favicon);
        commit('SET_PRIMARY_COLOR', data.primaryColor);
        commit('SET_SECONDARY_COLOR', data.secondaryColor);
        commit('SET_APP_NAME', data.appName);
        commit('SET_SOCIAL_LOGIN', data.socialLogin);
        commit('SET_GOOGLE_CAPTCHA_CLIENT_ID', data.googleCaptchaClientID);
        commit('SET_LOADED', true);
        return data;
      })
      .catch(error => {
        commit('SET_LOADED', true);
        throw new Error(error);
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
